import styled from 'styled-components';

import { Column } from '@riac/design-system';
import { IAuctionsPageTitle } from 'src/pages/AuctionsPage/AuctionsPage.i';
import { Content } from '@riac/design-system';

export const AuctionsPageContainer = styled(Column)`
  align-items: stretch;
  gap: 2em;

  margin-bottom: 2em 0;

  ${({ theme }) => theme.desktop} {
    margin-bottom: 4em 0;
  }
`;

export const AuctionsPageSection = styled.section`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;

  padding: 0 15px;

  ${({ theme }) => theme.desktop} {
    padding: 100px 0;
  }
`;

export const AuctionsPageTitle = styled.h2<IAuctionsPageTitle>`
  text-align: center;
  cursor: default;
  ${((props) => props.onClick && 'cursor: pointer;')}
  svg {
    color: ${({ theme }) => theme.gold[50]};
    font-size: 2rem;
    transform: rotate(${(props) => props.show ? -180 : 0}deg);
    transition: transform 0.5s;
  }
`;

export const AuctionsPageContent = styled(Content)`
  padding: 0; //TODO: After content's inbuilt padding is removed, remove this.
  margin-top: 100px;
`;

export const AuctionLocation = styled.h4`
  color: ${(props) => props.theme.black[50]};
`;
